module.exports = __webpack_public_path__ + "img/cuttingBoardTransparent.9d268610.png";